import {BaseContainerModel} from '../base-container.model';
import {app_login_mfa_RowClass} from '../../dbschema/app_login_mfa.model';

export class AppLoginMFAContainerModel extends BaseContainerModel {
  app_login_mfa: app_login_mfa_RowClass = new app_login_mfa_RowClass();
}
